module.exports = __webpack_public_path__ + "img/IMG_8996.622369fd.jpg";